function QASelectionsMarketGroup()
{
    this.GroupKey = null;
    this.Selections = [];
}

window.QASelectionsMarketGroup = QASelectionsMarketGroup;